import {
  DashboardDataReceipts,
  DashboardDataStatus,
} from 'src/routes/Dashboard/store/dashboardViewSlice/types';
import { ApiService } from './ApiService';
import { dashboardData } from './mockData';
import { DashboardDataExpenses } from './types';

// Generic function to fetch data
// const fetchData = async <T>(serviceName: ApiServiceName, filters: Filters): Promise<T> => {
//     const url = `https://your.api.endpoint/${serviceName}`; // Replace with your actual API endpoint
//     try {
//         const response = await axios.post<T>(url, {
//             params: filters,
//             headers: {
//                 Authorization: `Bearer ${yourAccessToken}`, // Replace with actual access token logic
//                 Accept: 'application/json'
//             }
//         });

//         return response.data;
//     } catch (error) {
//         throw new Error(`Error fetching data from ${serviceName} API`);
//     }
// };

// service methods names = get + ServiceName
export const ApiServiceImpl: ApiService = {
  getExpensesSummary: async (
    filters,
  ): Promise<DashboardDataExpenses['dataPoints']> => {
    // return fetchData<DashboardDataExpenses['dataPoints']>('expensesSummary', filters);
    return Promise.resolve(dashboardData.expenses.dataPoints);
  },
  getReceiptsSummary: async (
    filters,
  ): Promise<DashboardDataReceipts['total']> => {
    // return fetchData<DashboardDataReceipts['total']>('receiptsSummary', filters);

    return Promise.resolve(dashboardData.receipts.total);
  },
  getAccountStatus: async (
    filters,
  ): Promise<Pick<DashboardDataStatus, 'score' | 'violatingCount'>> => {
    // return fetchData<Pick<DashboardDataStatus, 'score' | 'violatingCount'>>('accountStatus', filters);
    const data: Pick<DashboardDataStatus, 'score' | 'violatingCount'> = {
      score: dashboardData.status.score,
      violatingCount: dashboardData.status.violatingCount,
    };
    return Promise.resolve(data);
  },
  getVendorsList: async (
    filters,
  ): Promise<DashboardDataReceipts['vendors']> => {
    // return fetchData<DashboardDataReceipts['vendors']>('vendorsList', filters);
    return Promise.resolve(dashboardData.receipts.vendors);
  },
};
